import { ChangeEvent } from "react";
import { DefaultOptions, Theme } from "../../types";
import Error from "./Error";

interface CheckboxItemProps {
  theme: Theme;
  name: string;
  label: string;
  value: string | number;
  checked: boolean;
  handleCheckboxItemChange: (
    e: ChangeEvent<HTMLInputElement>,
    value: string | number
  ) => void;
}

const CheckboxItem = ({
  name,
  label,
  value,
  checked,
  handleCheckboxItemChange,
  theme,
}: CheckboxItemProps) => (
  <label className="flex flex-row items-center gap-2 cursor-pointer">
    <input
      type="checkbox"
      name={name}
      id={value.toString()}
      value={label}
      checked={checked}
      onChange={(e) => handleCheckboxItemChange(e, value)}
      className={`appearance-none cursor-pointer focus:outline-none w-4 h-4 rounded-sm ${
        theme === "dark"
          ? "bg-white checked:bg-secondary"
          : "bg-lgray checked:bg-primary"
      }`}
    />
    {label}
  </label>
);

interface MultiCheckboxProps {
  theme?: Theme;
  fieldLabel: string;
  fieldName: string;
  defaultOptions: DefaultOptions;
  checkedValues: (string | number)[];
  handleChange: (
    e: ChangeEvent<HTMLInputElement>,
    value: string | number
  ) => void;
  error?: string;
}

const MultiCheckbox: React.FC<MultiCheckboxProps> = ({
  fieldLabel,
  fieldName,
  defaultOptions,
  checkedValues,
  handleChange,
  error,
  theme = "dark",
}) => (
  <div className="relative flex flex-col gap-1">
    <div className="flex flex-col gap-4">
      <label
        className={`text-base-regular ${
          theme === "dark" ? "text-secondary" : "text-primary"
        }`}
      >
        {fieldLabel}
      </label>
      {defaultOptions.map(({ label, value }) => (
        <CheckboxItem
          name={fieldName}
          key={value}
          label={label}
          value={value}
          checked={checkedValues.includes(value)}
          handleCheckboxItemChange={(e) => handleChange(e, value)}
          theme={theme}
        />
      ))}
    </div>
    {error && <Error message={error} />}
  </div>
);

export default MultiCheckbox;
